import { InjectionToken } from '@angular/core';
import { WorkbenchService } from '../services/configurators-2d/applications/workbench.service';
import { WorkbenchMaterialsColorsComponent } from '../pages/configurators-2d/workbench/materials-colors/materials-colors.component';
import { WorkbenchFinishesComponent } from '../pages/configurators-2d/workbench/finishes/finishes.component';
import { WorkbenchSummaryComponent } from '../pages/configurators-2d/workbench/summary/summary.component';
import { WorkbenchPlanGroupsComponent } from '../pages/configurators-2d/workbench/plan-groups/plan-groups.component';
import { WorkbenchSplashbacksComponent } from '../pages/configurators-2d/workbench/splashbacks/splashbacks.component';

export const WB_PLAN_GROUPS = new InjectionToken(typeof WorkbenchPlanGroupsComponent);
export const WB_COLORS = new InjectionToken(typeof WorkbenchMaterialsColorsComponent);
export const WB_SPLASHBACK = new InjectionToken(typeof WorkbenchSplashbacksComponent);
export const WB_FINISHES = new InjectionToken(typeof WorkbenchFinishesComponent);
export const WB_SUMMARY = new InjectionToken(typeof WorkbenchSummaryComponent);

export const WB_SERVICE = new InjectionToken(typeof WorkbenchService);

export const workbenchProviders = [
  {
    provide: WB_SERVICE,
    useClass: WorkbenchService,
  },
  {
    provide: WB_PLAN_GROUPS,
    useClass: WorkbenchPlanGroupsComponent,
  },
  {
    provide: WB_COLORS,
    useClass: WorkbenchMaterialsColorsComponent,
  },
  {
    provide: WB_SPLASHBACK,
    useClass: WorkbenchSplashbacksComponent,
  },
  {
    provide: WB_FINISHES,
    useClass: WorkbenchFinishesComponent,
  },
  {
    provide: WB_SUMMARY,
    useClass: WorkbenchSummaryComponent,
  },
];
